import {PropTypes, ShapeComponent, shapeComponent, StyleSheet, Text, View} from "shared/base"
import React, {useMemo} from "react"
import classNames from "classnames"
import {digs} from "diggerize"
import {HelperText} from "react-native-paper"
import memo from "set-state-compare/build/memo"
import useInput from "@kaspernj/api-maker/build/use-input"

const styles = StyleSheet.create({
  label: {color: "#aaa", fontSize: 12},
  labelContainer: {marginLeft: 10}
})

/**
 * @typedef {object} ComponentsUtilsInputProps
 * @property {unknown} autoRows
 * @property {unknown} children
 * @property {unknown} dataSet
 * @property {string} label
 * @property {number} minimumRows
 * @property {string} name
 * @property {Function} onChangeText
 * @property {unknown} onLayout
 * @property {unknown} required
 * @property {object} style
 * @property {object} styles
 */

/** @typedef {object} ComponentsUtilsInputState */

/**
 * @extends {ShapeComponent<ComponentsUtilsInputProps, ComponentsUtilsInputState>}
 */
class ComponentsUtilsInput extends ShapeComponent {
  static defaultProps = {
    autoRows: false,
    required: false
  }

  static propTypes = {
    autoRows: PropTypes.bool.isRequired,
    label: PropTypes.string,
    minimumRows: PropTypes.number,
    name: PropTypes.string,
    onChangeText: PropTypes.func,
    required: PropTypes.bool.isRequired,
    style: PropTypes.object,
    styles: PropTypes.object
  }

  setup() {
    const {wrapperOpts} = useInput({props: this.props, wrapperOptions: {type: "input"}})
    const {errors} = digs(wrapperOpts, "errors")

    this.errors = errors
  }

  render() {
    const {errors} = this.tt
    const {dataSet, label, onLayout, required} = this.props
    const {component, ...restDataSet} = dataSet || {}
    const actualDataSet = useMemo(() => {
      return Object.assign(
        {component: classNames("utils/input-container", component), inputName: this.props.name},
        restDataSet
      )
    }, [component, this.props.name, restDataSet])

    return (
      <View dataSet={actualDataSet} onLayout={onLayout} style={this.containerStyle ||= this.stylingFor("container")}>
        {label &&
          <View style={styles.labelContainer}>
            <Text style={styles.label}>
              {label}{required && " *"}
            </Text>
          </View>
        }
        <View>
          {this.props.children}
        </View>
        {errors.length > 0 &&
          <HelperText dataSet={this.helperTextDataSet ||= {class: "errors-helper-text"}} type="error">
            {this.errorMessages().join(". ")}
          </HelperText>
        }
      </View>
    )
  }

  errorMessages() {
    const {errors} = this.tt
    const errorMessages = []

    for (const error of errors) {
      for (const errorMessage of error.getErrorMessages()) {
        errorMessages.push(errorMessage)
      }
    }

    return errorMessages
  }
}

export default memo(shapeComponent(ComponentsUtilsInput))
